angular.module('unica_track.track_services')

.factory('TrackEditService', function ($http, getBaseApiURL) {

	var trackEditService = {};

	trackEditService.update = function (trackData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/track/update/' + trackData.id,
			data: trackData
		}).then(function(result) {

			if ( result ) {
				return result.data.track;
			}

		});

	};

	return trackEditService;
});